import colors from '../foundations/colors';

const Button = {
   baseStyle: {
      fontWeight: 'inherit',
   },
   sizes: {
      sm: {
         fontSize: '13px',
         height: '30px',
         py: '5px',
         px: '10px',
      },
   },
   variants: {
      outline: {
         bg: colors.white,
         borderColor: colors.gray[300],
         color: colors.black,
      },
   },
};

export default Button;
